import ngDialog from 'ng-dialog';
import 'angucomplete-alt';
import usefulDirectives from "../../helpers/usefulDirectives";
import pscData from './pscData';
import zujOrpDimensions from './orpZujData';


/**
 * XLS parsed by - http://oss.sheetjs.com/js-xlsx/
 * XLS got from - https://www.ceskaposta.cz/ke-stazeni/zakaznicke-vystupy
 */
export default angular.module('pscDimensions', [
	ngDialog,
	'angucomplete-alt',
	usefulDirectives
])
	.service('pscDimensions', function() {
		this.dimensions = [];

		/**
		 * Set default storage and set values
		 */
		// let db = low('app/services/pscDimensions/pscDimensions.json');
		// db.defaults([]).value();

		// this.dimensions = db.getState();
		this.dimensions = pscData;

		this.getDimensions = () => {
			return angular.copy(this.dimensions);
		};

		this.setDimensions = (dimensions) => {
			this.dimensions = angular.copy(dimensions);
		};
	}).directive('pscSelector', function() {
		return {
			template: `
				<a class="btn btn-{{ctrl.btnClass}}" uib-tooltip="{{ctrl.tooltip}}" ng-click="ctrl.openSelector()"><i class="fa fa-comment"></i></a>`,
			restrict: 'E',
			scope: {},
			replace: true,
			bindToController: {
				selectTo: '=',
				btnClass: '<',
				tooltip: '<',
				onSelect: '<'
			},
			controller: function(ngDialog, $scope, $timeout) {
				if (angular.isUndefined(this.tooltip)) {
					this.tooltip = 'Vybrat z číselníku';
				}

				if (angular.isUndefined(this.btnClass)) {
					this.btnClass = 'warning';
				}

				/**
				 * Open modal for changing password
				 */
				this.openSelector = () => {
					ngDialog.open({
						template: 'services/pscDimensions/selector.tpl.html',
						controller: function($scope, pscDimensions) {
							this.pscDimensions = pscDimensions.getDimensions();

							this.select = () => {
								if (angular.isDefined(this.selected)) {
									$scope.closeThisDialog({value: this.selected.originalObject});
								} else {
									$scope.closeThisDialog(false);
								}
							};
						},
						controllerAs: 'ctrl',
						name: 'pscSelectorDialog'
					}).closePromise.then((response) => {
						if (angular.isDefined(response.value.value)) {
							this.selectTo = parseInt(response.value.value.psc);

							if (angular.isFunction(this.onSelect)) {
								this.onSelect(response.value.value);
							}
						}
					});
				};

				/**
				 * Ugly, dirty OMFG solution, but this autocomplete does not support programmatic focus
				 */
				$scope.$on('ngDialog.opened', function(e, dialog) {
					if (dialog.name == 'pscSelectorDialog') {
						$timeout(() => {
							document.querySelector('#_value').focus();
						});
					}
				});
			},
			controllerAs: 'ctrl'
		};
	}).service('zujDimensions', function() {
		this.dimensions = [];

		/**
		 * Set default storage and set values
		 */
		// let db = low('app/services/pscDimensions/orpZujDimensions.json');
		// db.defaults([]).value();

		// this.dimensions = db.getState();
		this.dimensions = zujOrpDimensions;

		this.getDimensions = () => {
			let dimensions = angular.copy(this.dimensions);
			const yearNow = new Date().getFullYear();
			dimensions = dimensions.filter((d) => (d.datum_do > yearNow || d.datum_do === ""));
			return dimensions;
		};

		this.setDimensions = (dimensions) => {
			this.dimensions = angular.copy(dimensions);
			db.setState(this.dimensions);
		};
	}).directive('zujSelector', function() {
		return {
			template: `
				<a class="btn btn-{{ctrl.btnClass}}" uib-tooltip="{{ctrl.tooltip}}" ng-click="ctrl.openSelector()"><i class="fa fa-comment"></i></a>`,
			restrict: 'E',
			replace: true,
			scope: {},
			bindToController: {
				selectTo: '=',
				btnClass: '<',
				tooltip: '<',
				onSelect: '<',
				selectAttr: '<'
			},
			controller: function(ngDialog, $scope, $timeout) {
				if (angular.isUndefined(this.tooltip)) {
					this.tooltip = 'Vybrat z psc';
				}

				if (angular.isUndefined(this.btnClass)) {
					this.btnClass = 'warning';
				}

				var self = this; //srsly wtf, dunno why this must be here, but without it it is not working :(

				/**
				 * Open modal for changing password
				 */
				this.openSelector = () => {
					ngDialog.open({
						template: 'services/pscDimensions/zujSelector.tpl.html',
						controller: function($scope, zujDimensions) {
							this.zujDimensions = zujDimensions.getDimensions();

							this.select = () => {
								if (angular.isDefined(this.selected)) {
									$scope.closeThisDialog({value: this.selected.originalObject});
								} else {
									$scope.closeThisDialog(false);
								}
							};
						},
						controllerAs: 'ctrl',
						name: 'zujSelectorDialog'
					}).closePromise.then((response) => {
						if (angular.isDefined(response.value.value)) {
							this.selectTo = parseInt(response.value.value[this.selectAttr]);

							if (angular.isFunction(this.onSelect)) {
								this.onSelect(response.value.value);
							}
						}
					});
				};

				/**
				 * Ugly, dirty OMFG solution, but this autocomplete does not support programmatic focus
				 */
				$scope.$on('ngDialog.opened', function(e, dialog) {
					if (dialog.name == 'zujSelectorDialog') {
						$timeout(() => {
							document.querySelector('#_value').focus();
						});
					}
				});
			},
			controllerAs: 'ctrl'
		};
	})
	.name;



// WEBPACK FOOTER //
// build/services/pscDimensions/pscDimensions.js